import httpClient from '../httpClient';

export const getLanguages = () => {
  return httpClient({
    method: 'GET',
    url: `/common/languages`,
  });
};
